import api from "APP_ROOT/api";
import {
  createPaginatedList,
  paginationGroup
} from "MODULES/shared/pagination";
import { ID } from "APP_ROOT/constants";
import { config } from "MODULES/parts/pagination";
import { combineReducers } from "redux";
import { SHIPMENT } from "MODULES/Receiving/constants";

const SHIPMENTS = "shipments";

export const shipmentsPagination = createPaginatedList({
  listId: SHIPMENTS,
  fetch: api.shipments.search,
  stateLocator: state => state.shipmentsPagination.main
});

const [lineItems] = paginationGroup(
  {
    groupName: SHIPMENTS,
    getId: state => state.shipmentDetail.getIn([SHIPMENT, ID]),
    locate: ({ key }) => state => state.shipmentsPagination[key]
  },
  config("lineItems", false, api.shipments.lineItems.search)
);

export default combineReducers({
  main: shipmentsPagination.paginator,
  lineItems
});



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/pagination.js